import React from "react";
import {
  CurrentCount,
  MainContainerDiv,
  MainContainerHeading,
} from "./Dashboard.style";
import user from "../../Images/team.png";
import { Skeleton } from "@mui/material";

const TotalUser = ({ userData, dashboardTotalInfo, isLoading }) => {

  const forAdmin = dashboardTotalInfo?.total_user - 1;

  return (
    <MainContainerDiv
      style={{ background: "linear-gradient(to right, #314755, #26a0da)" }}
    >
      {userData?.ugleve_name === "Admin" ||
        userData?.ugleve_name === "Developer" ? (
        <div>
          <MainContainerHeading>Total user</MainContainerHeading>

          {isLoading ? (
            <CurrentCount>
              <Skeleton animation="wave" />
              {/* <SyncLoader color="#4e97fd" size={8} /> */}
            </CurrentCount>
          ) : (
            <div>
              {userData?.ugleve_name === "Admin" && (
                <CurrentCount>{forAdmin}</CurrentCount>
              )}
              {userData?.ugleve_name === "Developer" && (
                <CurrentCount>{dashboardTotalInfo?.total_user}</CurrentCount>
              )}
            </div>
          )}
        </div>
      ) : (
        <div>
          <MainContainerHeading>User Level</MainContainerHeading>

          {isLoading ? (
            <CurrentCount>
              <Skeleton />
            </CurrentCount>
          ) : (
            <div>
              <CurrentCount>{userData?.ugleve_name}</CurrentCount>
            </div>
          )}
        </div>
      )}

      <div>
        <img
          style={{
            height: "6rem",
            width: "6rem",
          }}
          src={user}
          alt=""
        />
      </div>
    </MainContainerDiv>
  );
};

export default TotalUser;
